import React from 'react';
import { useEmitterListener } from '@ace/react-utilities';
import { SMART_GOAL_DATA_EVENTS, queryProps } from 'Components/SMARTGoal/SMARTGoalHelper';
import useCard from 'context/CardContext';

export default function withSMARTGoalOnUpdateCardComponent(Component) {
    function WithSMARTGoalOnUpdateCard(props) {
        const { refreshCard, cardType } = useCard();
        const { data } = props;
        
        useEmitterListener(queryProps.updateUserGoal.componentName, SMART_GOAL_DATA_EVENTS.ON_OVERLAY_HIDDEN, (innerData) => {
            if (data?.IsSMARTGoalEnabled || false || cardType === 'PAKOverviewCard') {
                refreshCard();
            }
        });

        // useEmitterListener(queryProps.updateUserGoal.componentName, SMART_GOAL_DATA_EVENTS.ON_UPDATE_SETTLED, (innerData) => {
        //     if (data?.IsSMARTGoalEnabled || false || cardType === 'PAKOverviewCard') {
        //         refreshCard();
        //     }
        // });
        
        return (
            <Component {...props} />
        );
    }

    return WithSMARTGoalOnUpdateCard;
}